const values = {
    "FOOD_PACKAGES": "Food packages"
}

export default values;